import { observer } from 'mobx-react-lite';
import { FC } from 'react';
import { CSSTransition } from 'react-transition-group';

import { IcCloseRound16Icon, IcWarning16Icon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import { IconView, IconViewSizes } from '@gem/ui-kit';

import { useConnectionWarningPresenter } from './ConnectionWarning.presenter';
import styles from './ConnectionWarning.styles.m.css';

const ANIMATION_TIMEOUT = 250;

const itemTransition = {
  enter: styles.enter,
  enterActive: styles.enterActive,
  exit: styles.exit,
  exitActive: styles.exitActive,
};

interface IEventProps {}

export const ConnectionWarning: FC<IEventProps> = observer(() => {
  const presenter = useConnectionWarningPresenter();
  const { t } = useTranslation();

  return (
    <CSSTransition
      in={presenter.hasPoorConnection || presenter.hasReconnecting}
      classNames={itemTransition}
      timeout={ANIMATION_TIMEOUT}
      mountOnEnter
      unmountOnExit
    >
      <div className={styles.content}>
        <IconView
          Icon={presenter.hasPoorConnection ? IcWarning16Icon : IcCloseRound16Icon}
          className={styles.icon}
          size={IconViewSizes.Small}
        />
        {t(
          presenter.hasPoorConnection
            ? 'calls_unstable_connection_status'
            : 'calls_connection_lost_status'
        )}
      </div>
    </CSSTransition>
  );
});
